import { useContext } from "react";

import { ReconciliationServiceContext } from "@/provider/ReconciliationService";

const useReconciliation = () => {
  const context = useContext(ReconciliationServiceContext);
  if (!context) {
    throw new Error(
      "useReconciliation must be used within a ReconciliationProvider",
    );
  }
  return context;
};

export default useReconciliation;
